// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_shoes = /** @type {(inputs: {}) => string} */ () => {
	return `Shoes`
};

const el_shoes = /** @type {(inputs: {}) => string} */ () => {
	return `Παπούτσια`
};

const ru_shoes = /** @type {(inputs: {}) => string} */ () => {
	return `Обувь`
};

const he_shoes = /** @type {(inputs: {}) => string} */ () => {
	return `נעליים`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const shoes = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.shoes(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("shoes", locale)
	if (locale === "en") return en_shoes(inputs)
	if (locale === "el") return el_shoes(inputs)
	if (locale === "ru") return ru_shoes(inputs)
	if (locale === "he") return he_shoes(inputs)
	return "shoes"
};